<template>
  <div class="data-card">
    <h3 class="mt-0 mb-3">Клиент</h3>
    <el-form :model="form" :rules="rules" ref="form" class="grid-table" :class="[{ 'grid-table_border': !isEdited }]">
      <div class="grid-table__row">
        <p class="text-secondary">ФИО покупателя</p>
        <div>
          <el-form-item v-if="isEdited" prop="customerFullName">
            <el-input v-model="form.customerFullName" size="medium" />
          </el-form-item>
          <p v-else>{{ item.customerFullName }}</p>
        </div>
      </div>
      <div class="grid-table__row">
        <p class="text-secondary">Телефон</p>
        <div>
          <el-form-item v-if="isEdited" prop="customerPhone">
            <el-input v-model="form.customerPhone" size="medium" v-mask="MASKS.PHONE" />
            <input v-show="false" type="text" v-model="form.customerPhone" v-mask="MASKS.PHONE">
          </el-form-item>
          <p v-else>{{ item.customerPhone | VMask(MASKS.PHONE_WRITE) }}</p>
        </div>
      </div>
      <div class="grid-table__row">
        <p class="text-secondary">Доп. телефон</p>
        <div>
          <el-form-item v-if="isEdited" prop="customerAdditionalPhone">
            <el-input v-model="form.customerAdditionalPhone" size="medium" v-mask="MASKS.PHONE" />
            <input v-show="false" type="text" v-model="form.customerAdditionalPhone" v-mask="MASKS.PHONE">
          </el-form-item>
          <p v-else>{{ item.customerAdditionalPhone | VMask(MASKS.PHONE_WRITE)}}</p>
        </div>
      </div>
      <div class="grid-table__row grid-table__row_textarea">
        <p class="text-secondary">Адрес</p>
        <div>
          <el-form-item v-if="isEdited" prop="customerAddress">
            <el-input type="textarea" v-model="form.customerAddress" size="medium" resize="none" />
          </el-form-item>
          <p v-else>{{ item.customerAddress }}</p>
        </div>
      </div>
      <div class="grid-table__row grid-table__row_textarea">
        <p class="text-secondary">Комментарий</p>
        <div>
          <el-form-item v-if="isEdited" prop="customerComment">
            <el-input type="textarea"
                      v-model="form.customerComment"
                      :rows="4"
                      maxlength="200"
                      show-word-limit
                      size="medium"
                      resize="none" />
          </el-form-item>
          <p v-else>{{ item.customerComment }}</p>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { MESSAGES } from '@/commons/constants/errorMessages';
import MASKS from '@/commons/constants/masks';

export default {
  props: {
    isEdited: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    form: {
      customerFullName: '',
      customerPhone: '',
      customerAdditionalPhone: '',
      customerAddress: '',
      customerComment: '',
    },
    rules: {
      customerFullName: [{ required: true, message: MESSAGES.REQUIRED, trigger: 'change' }],
      customerPhone: [
        { required: true, message: MESSAGES.REQUIRED, trigger: 'change' },
        {
          min: 18, max: 18, message: MESSAGES.INCORRECT_PHONE, trigger: 'blur',
        },
      ],
      customerAdditionalPhone: [
        {
          min: 18, max: 18, message: MESSAGES.INCORRECT_PHONE, trigger: 'blur',
        },
      ],
      customerAddress: [{ required: true, message: MESSAGES.REQUIRED, trigger: 'blur' }],
      // comment: [{ required: true, message: MESSAGES.REQUIRED, trigger: 'blur' }],
    },
    MASKS,
  }),
  created() {
    this.fillForm();
  },
  computed: {
    ...mapGetters({
      item: 'orders/item',
    }),
  },
  methods: {
    fillForm() {
      if (this.item) {
        this.form.customerFullName = this.item.customerFullName;
        this.form.customerPhone = this.item.customerPhone || '';
        this.form.customerAdditionalPhone = this.item.customerAdditionalPhone || '';
        this.form.customerAddress = this.item.customerAddress;
        this.form.customerComment = this.item.customerComment;
      } else {
        this.form.customerFullName = '';
        this.form.customerPhone = '';
        this.form.customerAdditionalPhone = '';
        this.form.customerAddress = '';
        this.form.customerComment = '';
      }
    },
    onSave() {
      let isValid = false;
      this.$refs.form.validate((valid) => {
        isValid = valid;
      });
      const form = {
        clientName: this.form.customerFullName,
        clientPhone: this.form.customerPhone.toString().match(/\d+/g)?.join('').toString(),
        clientAdditionalPhone: this.form.customerAdditionalPhone.toString().match(/\d+/g)?.join('').toString(),
        address: this.form.customerAddress,
        comment: this.form.customerComment,
      };
      return { isValid, form };
    },
  },
  watch: {
    item() {
      this.fillForm();
    },
  },
};
</script>
